<div class="modal-header">
  <h5 class="modal-title text-capitalize" id="myModalLabel">{{labelConstants.ChangePassword}}</h5>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
    (click)="onClose('cancel')"></button>
</div>
<div class="modal-body">
  <form [formGroup]="resetPasswordForm" (ngSubmit)="submitResetPassForm()">
    <div>
      <div class="form-group mb-4">
        <label>{{ labelConstants.CurrentPassword}}<span class="text-danger">*</span></label>
        <div class="position-relative mb-1">
          <app-loader [count]="1" [appearance]="'line'" [isLoading]="isLoading">
            <input oninput="this.value = this.value.replace(/^\s+/g, '')"
              [type]="showCurrentPasseword ? 'text' : 'password'" class="form-control" formControlName="CurrentPassword"
              placeholder="Current password" maxlength="16" required />
          </app-loader>
          <i class="fa-regular fa-eye visibility cursor eye-visibility" *ngIf="!showCurrentPasseword"
            (click)="togglePasswordVisibility('showCurrentPasseword')"></i>
          <i class="fa-regular fa-eye-slash visibility cursor eye-visibility" *ngIf="showCurrentPasseword"
            (click)="togglePasswordVisibility('showCurrentPasseword')"></i>
        </div>
        <span class="text-danger"
          *ngIf="submitted && resetPasswordForm.get('CurrentPassword')?.hasError('required')">{{errorConstants.CurrentPassRequired}}</span>
      </div>
      <div class="form-group mb-4">
        <label>{{ labelConstants.NewPassword}}<span class="text-danger">*</span></label>
        <div class="position-relative mb-1">
          <app-loader [count]="1" [appearance]="'line'" [isLoading]="isLoading">
            <input oninput="this.value = this.value.replace(/^\s+/g, '')" [type]="showNewPassword ? 'text' : 'password'"
              class="form-control" formControlName="NewPassword" placeholder="New password" maxlength="16"
              (focus)="togglePasswordRequirements(true)" (blur)="togglePasswordRequirements(false)"
              (input)="checkPasswordValidity()" />
          </app-loader>
          <i class="fa-regular fa-eye visibility cursor eye-visibility" *ngIf="!showNewPassword"
            (click)="togglePasswordVisibility('showNewPassword')"></i>
          <i class="fa-regular fa-eye-slash visibility cursor eye-visibility" *ngIf="showNewPassword"
            (click)="togglePasswordVisibility('showNewPassword')"></i>
        </div>
        <span class="text-danger"
          *ngIf="submitted && resetPasswordForm.get('NewPassword')?.hasError('required')">{{errorConstants.NewPassRequired
          }}</span>
        <span class="text-danger"
          *ngIf="submitted && changePassControls['NewPassword'].errors?.['pattern']">{{errorConstants.NewPassInvalid
          }}</span>
        <span class="text-danger"
          *ngIf="resetPasswordForm.hasError('samePassword') && resetPasswordForm.get('NewPassword')?.touched">
          {{ errorConstants.NewPassNotMatch }}
        </span>
      </div>
      <div class="form-group mb-4">
        <label>{{ labelConstants.ConfirmPassword}}<span class="text-danger">*</span></label>
        <div class="position-relative mb-1">
          <app-loader [count]="1" [appearance]="'line'" [isLoading]="isLoading">
            <input oninput="this.value = this.value.replace(/^\s+/g, '')"
              [type]="showConfirmPassword ? 'text' : 'password'" class="form-control"
              formControlName="ConfirmNewPassword" placeholder="Confirm password" maxlength="16" />
          </app-loader>
          <i class="fa-regular fa-eye visibility cursor eye-visibility" *ngIf="!showConfirmPassword"
            (click)="togglePasswordVisibility('showConfirmPassword')"></i>
          <i class="fa-regular fa-eye-slash visibility cursor eye-visibility" *ngIf="showConfirmPassword"
            (click)="togglePasswordVisibility('showConfirmPassword')"></i>
        </div>
        <span class="text-danger"
          *ngIf="submitted && resetPasswordForm.get('ConfirmNewPassword')?.hasError('required')">{{errorConstants.ConfPassRequired
          }}</span>
        <span class="text-danger"
          *ngIf="submitted && resetPasswordForm.errors?.['mismatch'] && resetPasswordForm.get('ConfirmNewPassword')?.touched">
          {{ errorConstants.PassNotMatch }}
        </span>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary-datalist" data-bs-dismiss="modal" (click)="onClose('cancel')">
        {{commonConstants.Close}}
      </button>
      <button type="submit" class="btn btn-primary-datalist">
        {{commonConstants.Save}}
      </button>
    </div>
  </form>
</div>